<td class="px-2">
  @if (timer.timerState === 'active') {
    <button
      (click)="stop.emit(); $event.stopPropagation()"
      class="hover:bg-blue-200 bg-blue-100 text-primary dark:bg-blue-900 dark:hover:bg-blue-800 rounded-full w-12 h-12 sm:w-8 sm:h-8 flex justify-center items-center"
    >
      <app-ng-icon strokeWidth="2" name="heroPause" class="text-2xl sm:text-lg"></app-ng-icon>
    </button>
  } @else {
    @if (timer.timerState === 'inactive' && !timer.outdated) {
      <button
        (click)="start.emit(timer.timerId); $event.stopPropagation()"
        class="hover:bg-blue-200 bg-blue-100 text-primary dark:bg-blue-900 dark:hover:bg-blue-800 rounded-full w-12 h-12 sm:w-8 sm:h-8 flex justify-center items-center"
      >
        <app-ng-icon strokeWidth="2" name="heroPlay"></app-ng-icon>
      </button>
    } @else {
      <app-ng-icon
        name="heroExclamationTriangle"
        class="py-4 text-red-600"
        tp="Ungespeichert"
        tpPlacement="top"
      ></app-ng-icon>
    }
  }
</td>
<td
  class="py-4 pl-4 pr-3 text-sm font-medium text-fg-primary sm:pl-0 truncate"
  [tp]="timer.projectDisplayName"
  tpOnlyTextOverflow
>
  {{ timer.projectDisplayName || '' }}

  <div class="sm:hidden text-fg-secondary text-xs">
    {{ timer.positionDisplayName || '' }}
  </div>
</td>
<td
  class="hidden whitespace-nowrap px-3 py-4 text-sm text-fg-secondary sm:table-cell truncate"
  [tp]="timer.positionDisplayName"
  tpOnlyTextOverflow
>
  {{ timer.positionDisplayName || '' }}
</td>
<td class="hidden px-3 py-4 text-sm text-fg-secondary lg:table-cell">
  <div class="line-clamp-3 2xl:line-clamp-none break-all">
    {{ timer.description }}
  </div>
</td>
<td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary text-right tabular-nums">
  {{ timer.workMinutes | formatWork }}
</td>
<td
  class="whitespace-nowrap text-fg-secondary text-right text-sm flex justify-between items-center py-4"
>
  @if (timer.timerState === 'active' && timer.startTime) {
    <span class="tabular-nums text-sm justify-self-start"
      >+ {{ timer.startTime | secondsPassed | formatSeconds }}</span
    >
  } @else {
    <span></span>
  }
  <app-ng-icon
    name="heroArrowRight"
    class="arrow-button text-lg text-primary col-start-2 justify-self-end w-12 h-12 sm:w-8 sm:h-8 rounded-full flex justify-center items-center"
  ></app-ng-icon>
</td>
